import { css } from 'styled-components';
import { blenderCss } from '@clds/blender';
/**
 * Populate Chip with variables so blenderCss-supporting components can reflect current blend
 * @param props props of Chip component
 */
export const blenderStyleMixin = (props) => {
    if (props.isSelected) {
        return css `
      ${blenderCss.populateVariables(getBlenderPropsForState('selected', props.variant, props.tone))};
      &:hover {
        ${blenderCss.populateVariables(getBlenderPropsForState('selectedHover', props.variant, props.tone))};
      }
    `;
    }
    return css `
    ${blenderCss.populateVariables(getBlenderPropsForState('normal', props.variant, props.tone))};
    ${props.isHoverable &&
        css `
      &:hover {
        ${blenderCss.populateVariables(getBlenderPropsForState('hover', props.variant, props.tone))};
      }
    `}
  `;
};
const intensityByState = {
    subtle: {
        normal: 'sm',
        hover: 'xl',
        selected: 'sm',
        selectedHover: 'xl',
    },
    solid: {
        normal: 'md',
        hover: 'sm',
        selected: 'md',
        selectedHover: 'sm',
    },
};
export const getBlenderPropsForState = (state, variant, tone) => {
    return {
        mode: tone === 'solid' ? 'solidContrast' : 'surfaceSolid',
        variant,
        intensity: intensityByState[tone][state],
    };
};
//# sourceMappingURL=blenderStyleMixin.js.map